// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var DOM_HTML_Indexed_InputType = require("../DOM.HTML.Indexed.InputType/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Formless_Action = require("../Formless.Action/index.js");
var Formless_Class_Initial = require("../Formless.Class.Initial/index.js");
var Formless_Component = require("../Formless.Component/index.js");
var Formless_Internal_Transform = require("../Formless.Internal.Transform/index.js");
var Formless_Retrieve = require("../Formless.Retrieve/index.js");
var Formless_Transform_Record = require("../Formless.Transform.Record/index.js");
var Formless_Transform_Row = require("../Formless.Transform.Row/index.js");
var Formless_Types_Component = require("../Formless.Types.Component/index.js");
var Formless_Types_Form = require("../Formless.Types.Form/index.js");
var Formless_Validation = require("../Formless.Validation/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML = require("../Halogen.HTML/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Heterogeneous_Mapping = require("../Heterogeneous.Mapping/index.js");
var Lunarbox_Capability_Navigate = require("../Lunarbox.Capability.Navigate/index.js");
var Lunarbox_Capability_Resource_Project = require("../Lunarbox.Capability.Resource.Project/index.js");
var Lunarbox_Capability_Resource_Tutorial = require("../Lunarbox.Capability.Resource.Tutorial/index.js");
var Lunarbox_Component_Error = require("../Lunarbox.Component.Error/index.js");
var Lunarbox_Component_Icon = require("../Lunarbox.Component.Icon/index.js");
var Lunarbox_Component_Loading = require("../Lunarbox.Component.Loading/index.js");
var Lunarbox_Component_Tooltip = require("../Lunarbox.Component.Tooltip/index.js");
var Lunarbox_Component_Typeahead = require("../Lunarbox.Component.Typeahead/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Data_Gist = require("../Lunarbox.Data.Gist/index.js");
var Lunarbox_Data_ProjectId = require("../Lunarbox.Data.ProjectId/index.js");
var Lunarbox_Data_Route = require("../Lunarbox.Data.Route/index.js");
var Lunarbox_Data_Tutorial = require("../Lunarbox.Data.Tutorial/index.js");
var Lunarbox_Form_Field = require("../Lunarbox.Form.Field/index.js");
var Lunarbox_Form_Validation = require("../Lunarbox.Form.Validation/index.js");
var Network_RemoteData = require("../Network.RemoteData/index.js");
var Record = require("../Record/index.js");
var Select = require("../Select/index.js");
var Base = (function () {
    function Base() {

    };
    Base.value = new Base();
    return Base;
})();
var Solution = (function () {
    function Solution() {

    };
    Solution.value = new Solution();
    return Solution;
})();
var TutorialForm = function (x) {
    return x;
};
var HandleTutorial = (function () {
    function HandleTutorial(value0) {
        this.value0 = value0;
    };
    HandleTutorial.create = function (value0) {
        return new HandleTutorial(value0);
    };
    return HandleTutorial;
})();
var Delete = (function () {
    function Delete() {

    };
    Delete.value = new Delete();
    return Delete;
})();
var Play = (function () {
    function Play() {

    };
    Play.value = new Play();
    return Play;
})();
var Init = (function () {
    function Init() {

    };
    Init.value = new Init();
    return Init;
})();
var HandleTypeahead = (function () {
    function HandleTypeahead(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    HandleTypeahead.create = function (value0) {
        return function (value1) {
            return new HandleTypeahead(value0, value1);
        };
    };
    return HandleTypeahead;
})();
var newtypeTutorialForm = new Data_Newtype.Newtype(function (n) {
    return n;
}, TutorialForm);
var eqUserProjectTypeahead = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Base && y instanceof Base) {
            return true;
        };
        if (x instanceof Solution && y instanceof Solution) {
            return true;
        };
        return false;
    };
});
var ordUserProjectTypeahead = new Data_Ord.Ord(function () {
    return eqUserProjectTypeahead;
}, function (x) {
    return function (y) {
        if (x instanceof Base && y instanceof Base) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Base) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Base) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Solution && y instanceof Solution) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Lunarbox.Component.TutorialEditor (line 201, column 1 - line 201, column 68): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var formComponent = function (dictMonadAff) {
    var singleTypeahead = function (slot) {
        return function (input) {
            var handler = (function () {
                var $92 = HandleTypeahead.create(slot);
                return function ($93) {
                    return Data_Maybe.Just.create(Formless_Action.injAction($92($93)));
                };
            })();
            return Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                return "typeahead";
            }))(ordUserProjectTypeahead)(Lunarbox_Component_Typeahead["_typeahead"])(slot)(Select.component(dictMonadAff)()()()(Lunarbox_Component_Typeahead.input(Data_Maybe.monoidMaybe(Lunarbox_Data_Tutorial.semigroupUserProject)))(Lunarbox_Component_Typeahead.single(dictMonadAff)(Lunarbox_Data_Tutorial.showUserProject)(Lunarbox_Data_Tutorial.eqUserProject)(Lunarbox_Data_Tutorial.semigroupUserProject)))(input)(handler);
        };
    };
    var proxies = Formless_Transform_Row.mkSProxies()(newtypeTutorialForm)(Formless_Transform_Row.makeSProxiesCons(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))()(Formless_Transform_Row.makeSProxiesCons(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))()(Formless_Transform_Row.makeSProxiesCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))()(Formless_Transform_Row.makeSProxiesCons(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))()(Formless_Transform_Row.makeSProxiesNil)))))(Formless_Types_Form.FormProxy.value);
    var render = function (v) {
        return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("form") ])([ Halogen_HTML_Elements.div_([ Lunarbox_Form_Field.input(new Data_Symbol.IsSymbol(function () {
            return "name";
        }))(newtypeTutorialForm)(newtypeTutorialForm)()()(proxies.name)(v.form)([ Halogen_HTML_Properties.placeholder("Name"), Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputText.value) ]), Lunarbox_Form_Field.input(new Data_Symbol.IsSymbol(function () {
            return "content";
        }))(newtypeTutorialForm)(newtypeTutorialForm)()()(proxies.content)(v.form)([ Halogen_HTML_Properties.placeholder("Gist id"), Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputText.value) ]), Lunarbox_Form_Field.customFormField(new Data_Symbol.IsSymbol(function () {
            return "base";
        }))(newtypeTutorialForm)(newtypeTutorialForm)()()(proxies.base)(v.form)(singleTypeahead(Base.value)({
            placeholder: "My awesome base project",
            items: v.projects,
            selected: Formless_Retrieve.getInput(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))(newtypeTutorialForm)()(proxies.base)(v.form)
        })), Lunarbox_Form_Field.customFormField(new Data_Symbol.IsSymbol(function () {
            return "solution";
        }))(newtypeTutorialForm)(newtypeTutorialForm)()()(proxies.solution)(v.form)(singleTypeahead(Solution.value)({
            placeholder: "My awesome solution",
            items: v.projects,
            selected: Formless_Retrieve.getInput(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))(newtypeTutorialForm)()(proxies.solution)(v.form)
        })), Lunarbox_Form_Field.submit("Save") ]) ]);
    };
    var handleAction = (function () {
        var $$eval = function (act) {
            return Formless_Component.handleAction(dictMonadAff)()()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))(Formless_Types_Form.eqInputField(Data_Maybe.eqMaybe(Lunarbox_Data_Tutorial.eqUserProject))))()(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))(Formless_Types_Form.eqInputField(Data_Eq.eqString)))()(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))(Formless_Types_Form.eqInputField(Data_Eq.eqString)))()(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))(Formless_Types_Form.eqInputField(Data_Maybe.eqMaybe(Lunarbox_Data_Tutorial.eqUserProject))))(Formless_Internal_Transform.inputFieldsToFormFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))()(Formless_Internal_Transform.inputFieldsToFormFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))()(Formless_Internal_Transform.inputFieldsToFormFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))()(Formless_Internal_Transform.inputFieldsToFormFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))()(Formless_Internal_Transform.inputFieldsToFormFieldsNil)())())())())(Formless_Internal_Transform.inputFieldsToInputCons(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))()(Formless_Internal_Transform.inputFieldsToInputCons(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))()(Formless_Internal_Transform.inputFieldsToInputCons(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))()(Formless_Internal_Transform.inputFieldsToInputCons(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))()(Formless_Internal_Transform.inputFieldsToInputNil)())())())())(Formless_Internal_Transform.consCountErrors(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))()(Formless_Internal_Transform.consCountErrors(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))()(Formless_Internal_Transform.consCountErrors(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))()(Formless_Internal_Transform.consCountErrors(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))()(Formless_Internal_Transform.nilCountErrors)))))(Formless_Internal_Transform.consAllTouched(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))()(Formless_Internal_Transform.consAllTouched(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))()(Formless_Internal_Transform.consAllTouched(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))()(Formless_Internal_Transform.consAllTouched(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))()(Formless_Internal_Transform.nilAllTouched)))))(Formless_Internal_Transform.setFormFieldsTouchedCons(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))()(Formless_Internal_Transform.setFormFieldsTouchedCons(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))()(Formless_Internal_Transform.setFormFieldsTouchedCons(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))()(Formless_Internal_Transform.setFormFieldsTouchedCons(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))()(Formless_Internal_Transform.setFormFieldsTouchedNil)())())())())(Formless_Internal_Transform.replaceFormFieldInputsTouchedCons(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))(Formless_Types_Form.newtypeInputField)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.replaceFormFieldInputsTouchedCons(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))(Formless_Types_Form.newtypeInputField)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.replaceFormFieldInputsTouchedCons(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))(Formless_Types_Form.newtypeInputField)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.replaceFormFieldInputsTouchedCons(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))(Formless_Types_Form.newtypeInputField)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.replaceFormFieldInputsTouchedNil)))))(Formless_Internal_Transform.modifyAllCons(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))(Formless_Types_Form.newtypeInputFunction)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.modifyAllCons(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))(Formless_Types_Form.newtypeInputFunction)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.modifyAllCons(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))(Formless_Types_Form.newtypeInputFunction)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.modifyAllCons(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))(Formless_Types_Form.newtypeInputFunction)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.modifyAllNil)))))(Formless_Internal_Transform.applyToValidationCons(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))((dictMonadAff.MonadEffect0()).Monad0())()(newtypeTutorialForm)()()(Formless_Internal_Transform.applyToValidationCons(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))((dictMonadAff.MonadEffect0()).Monad0())()(newtypeTutorialForm)()()(Formless_Internal_Transform.applyToValidationCons(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))((dictMonadAff.MonadEffect0()).Monad0())()(newtypeTutorialForm)()()(Formless_Internal_Transform.applyToValidationCons(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))((dictMonadAff.MonadEffect0()).Monad0())()(newtypeTutorialForm)()()(Formless_Internal_Transform.applyToValidationNil((dictMonadAff.MonadEffect0()).Monad0()))))))(Formless_Internal_Transform.formFieldsToMaybeOutputCons(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))()(Formless_Internal_Transform.formFieldsToMaybeOutputCons(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))()(Formless_Internal_Transform.formFieldsToMaybeOutputCons(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))()(Formless_Internal_Transform.formFieldsToMaybeOutputCons(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))()(Formless_Internal_Transform.formFieldsToMaybeOutputNil)())())())())(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)()(handleAction)(Formless_Component.raiseResult(newtypeTutorialForm)(Heterogeneous_Mapping.hmapRecord()(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))(Heterogeneous_Mapping.constMapping(Formless_Transform_Record.unwrapField(Formless_Types_Form.newtypeOutputField)))(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))(Heterogeneous_Mapping.constMapping(Formless_Transform_Record.unwrapField(Formless_Types_Form.newtypeOutputField)))(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))(Heterogeneous_Mapping.constMapping(Formless_Transform_Record.unwrapField(Formless_Types_Form.newtypeOutputField)))(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))(Heterogeneous_Mapping.constMapping(Formless_Transform_Record.unwrapField(Formless_Types_Form.newtypeOutputField)))(Heterogeneous_Mapping.mapRecordWithIndexNil)()())()())()())()())))(act);
        };
        return function (v) {
            if (v.value0 instanceof Base) {
                return $$eval(Formless_Action.setValidate(new Data_Symbol.IsSymbol(function () {
                    return "base";
                }))(newtypeTutorialForm)()(proxies.base)(v.value1.value0));
            };
            if (v.value0 instanceof Solution) {
                return $$eval(Formless_Action.setValidate(new Data_Symbol.IsSymbol(function () {
                    return "solution";
                }))(newtypeTutorialForm)()(proxies.solution)(v.value1.value0));
            };
            throw new Error("Failed pattern match at Lunarbox.Component.TutorialEditor (line 234, column 56 - line 236, column 60): " + [ v.value0.constructor.name ]);
        };
    })();
    var formInput = function (v) {
        return {
            validators: {
                name: Formless_Validation.noValidation((dictMonadAff.MonadEffect0()).Monad0()),
                base: Lunarbox_Form_Validation.exists((dictMonadAff.MonadEffect0()).Monad0()),
                solution: Lunarbox_Form_Validation.exists((dictMonadAff.MonadEffect0()).Monad0()),
                content: Formless_Validation.hoistFnE_((dictMonadAff.MonadEffect0()).Monad0())(function ($94) {
                    return Data_Either.Right.create(Lunarbox_Data_Gist.GistId($94));
                })
            },
            projects: v.projects,
            initialInputs: new Data_Maybe.Just(v.spec)
        };
    };
    return Formless_Component.component(dictMonadAff)()()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))(Formless_Types_Form.eqInputField(Data_Maybe.eqMaybe(Lunarbox_Data_Tutorial.eqUserProject))))()(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))(Formless_Types_Form.eqInputField(Data_Eq.eqString)))()(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))(Formless_Types_Form.eqInputField(Data_Eq.eqString)))()(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))(Formless_Types_Form.eqInputField(Data_Maybe.eqMaybe(Lunarbox_Data_Tutorial.eqUserProject))))(Formless_Internal_Transform.inputFieldsToFormFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))()(Formless_Internal_Transform.inputFieldsToFormFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))()(Formless_Internal_Transform.inputFieldsToFormFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))()(Formless_Internal_Transform.inputFieldsToFormFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))()(Formless_Internal_Transform.inputFieldsToFormFieldsNil)())())())())(Formless_Internal_Transform.inputFieldsToInputCons(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))()(Formless_Internal_Transform.inputFieldsToInputCons(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))()(Formless_Internal_Transform.inputFieldsToInputCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))()(Formless_Internal_Transform.inputFieldsToInputCons(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))()(Formless_Internal_Transform.inputFieldsToInputNil)())())())())(Formless_Internal_Transform.consCountErrors(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))()(Formless_Internal_Transform.consCountErrors(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))()(Formless_Internal_Transform.consCountErrors(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))()(Formless_Internal_Transform.consCountErrors(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))()(Formless_Internal_Transform.nilCountErrors)))))(Formless_Internal_Transform.consAllTouched(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))()(Formless_Internal_Transform.consAllTouched(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))()(Formless_Internal_Transform.consAllTouched(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))()(Formless_Internal_Transform.consAllTouched(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))()(Formless_Internal_Transform.nilAllTouched)))))(Formless_Internal_Transform.setFormFieldsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))()(Formless_Internal_Transform.setFormFieldsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))()(Formless_Internal_Transform.setFormFieldsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))()(Formless_Internal_Transform.setFormFieldsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))()(Formless_Internal_Transform.setFormFieldsTouchedNil)())())())())(Formless_Internal_Transform.replaceFormFieldInputsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))(Formless_Types_Form.newtypeInputField)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.replaceFormFieldInputsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))(Formless_Types_Form.newtypeInputField)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.replaceFormFieldInputsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))(Formless_Types_Form.newtypeInputField)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.replaceFormFieldInputsTouchedCons(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))(Formless_Types_Form.newtypeInputField)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.replaceFormFieldInputsTouchedNil)))))(Formless_Internal_Transform.modifyAllCons(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))(Formless_Types_Form.newtypeInputFunction)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.modifyAllCons(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))(Formless_Types_Form.newtypeInputFunction)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.modifyAllCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))(Formless_Types_Form.newtypeInputFunction)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.modifyAllCons(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))(Formless_Types_Form.newtypeInputFunction)(Formless_Types_Form.newtypeFormField)()()()(Formless_Internal_Transform.modifyAllNil)))))(Formless_Internal_Transform.applyToValidationCons(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))((dictMonadAff.MonadEffect0()).Monad0())()(newtypeTutorialForm)()()(Formless_Internal_Transform.applyToValidationCons(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))((dictMonadAff.MonadEffect0()).Monad0())()(newtypeTutorialForm)()()(Formless_Internal_Transform.applyToValidationCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))((dictMonadAff.MonadEffect0()).Monad0())()(newtypeTutorialForm)()()(Formless_Internal_Transform.applyToValidationCons(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))((dictMonadAff.MonadEffect0()).Monad0())()(newtypeTutorialForm)()()(Formless_Internal_Transform.applyToValidationNil((dictMonadAff.MonadEffect0()).Monad0()))))))(Formless_Internal_Transform.formFieldsToMaybeOutputCons(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))()(Formless_Internal_Transform.formFieldsToMaybeOutputCons(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))()(Formless_Internal_Transform.formFieldsToMaybeOutputCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))()(Formless_Internal_Transform.formFieldsToMaybeOutputCons(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))()(Formless_Internal_Transform.formFieldsToMaybeOutputNil)())())())())(Formless_Transform_Row.mkInputFieldsFromRowCons(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))(Formless_Class_Initial.initialMaybe)()(Formless_Transform_Row.mkInputFieldsFromRowCons(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))(Formless_Class_Initial.initialString)()(Formless_Transform_Row.mkInputFieldsFromRowCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))(Formless_Class_Initial.initialString)()(Formless_Transform_Row.mkInputFieldsFromRowCons(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))(Formless_Class_Initial.initialMaybe)()(Formless_Transform_Row.mkInputFieldsFromRowNil)())())())())(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)(newtypeTutorialForm)()()()()()()()()()(formInput)({
        render: render,
        handleAction: handleAction,
        handleQuery: Formless_Component.defaultSpec.handleQuery,
        handleEvent: Formless_Component.raiseResult(newtypeTutorialForm)(Heterogeneous_Mapping.hmapRecord()(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
            return "base";
        }))(Heterogeneous_Mapping.constMapping(Formless_Transform_Record.unwrapField(Formless_Types_Form.newtypeOutputField)))(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
            return "content";
        }))(Heterogeneous_Mapping.constMapping(Formless_Transform_Record.unwrapField(Formless_Types_Form.newtypeOutputField)))(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
            return "name";
        }))(Heterogeneous_Mapping.constMapping(Formless_Transform_Record.unwrapField(Formless_Types_Form.newtypeOutputField)))(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
            return "solution";
        }))(Heterogeneous_Mapping.constMapping(Formless_Transform_Record.unwrapField(Formless_Types_Form.newtypeOutputField)))(Heterogeneous_Mapping.mapRecordWithIndexNil)()())()())()())()())),
        receive: Formless_Component.defaultSpec.receive,
        initialize: Formless_Component.defaultSpec.initialize,
        finalize: Formless_Component.defaultSpec.finalize
    });
};
var component = function (dictMonadAff) {
    return function (dictManageProjects) {
        return function (dictManageTutorials) {
            return function (dictNavigate) {
                var render = function (v) {
                    if (v.projects instanceof Network_RemoteData.Success && v.tutorial instanceof Network_RemoteData.Success) {
                        var mkUserProject = function (target) {
                            var go = function (v1) {
                                return Data_Eq.eq(Lunarbox_Data_ProjectId.eqProjectId)(v1.value1)(target);
                            };
                            return Data_Foldable.find(Data_Foldable.foldableArray)(go)(v.projects.value0);
                        };
                        return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("tutorial-editor") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("tutorial-editor__main") ])([ Halogen_HTML_Elements.header([ Lunarbox_Component_Utils.className("tutorial-editor__header") ])([ Halogen_HTML_Elements.h1([ Lunarbox_Component_Utils.className("tutorial-editor__title") ])([ Halogen_HTML_Core.text("Edit tutorial") ]), Lunarbox_Component_Tooltip.tooltip("Delete this tutorial")(Lunarbox_Component_Tooltip.BottomLeft.value)(Halogen_HTML_Elements.button)([ Lunarbox_Component_Utils.className("tutorial-editor__header-icon"), Halogen_HTML_Events.onClick(Data_Function["const"](new Data_Maybe.Just(Delete.value))) ])([ Lunarbox_Component_Icon.icon("delete") ]), Lunarbox_Component_Tooltip.tooltip("Try out this tutorial")(Lunarbox_Component_Tooltip.Left.value)(Halogen_HTML_Elements.button)([ Lunarbox_Component_Utils.className("tutorial-editor__header-icon"), Halogen_HTML_Events.onClick(Data_Function["const"](new Data_Maybe.Just(Play.value))) ])([ Lunarbox_Component_Icon.icon("play_arrow") ]) ]), Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                            return "formless";
                        }))(Data_Ord.ordUnit)(Formless_Types_Component["_formless"])(Data_Unit.unit)(formComponent(dictMonadAff))({
                            projects: v.projects.value0,
                            spec: {
                                name: v.tutorial.value0.name,
                                base: Formless_Types_Form.InputField(mkUserProject(v.tutorial.value0.base)),
                                solution: Formless_Types_Form.InputField(mkUserProject(v.tutorial.value0.solution)),
                                content: Formless_Types_Form.InputField(Data_Newtype.unwrap(Lunarbox_Data_Gist.newtypeGistId)(v.tutorial.value0.content))
                            }
                        })(function ($95) {
                            return Data_Maybe.Just.create(HandleTutorial.create($95));
                        }) ]) ]);
                    };
                    if (v.projects instanceof Network_RemoteData.Failure) {
                        return Lunarbox_Component_Error.error(v.projects.value0);
                    };
                    if (v.tutorial instanceof Network_RemoteData.Failure) {
                        return Lunarbox_Component_Error.error(v.tutorial.value0);
                    };
                    return Lunarbox_Component_Loading.loading;
                };
                var fetchTutorial = Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v) {
                    return v.id;
                }))(function (id) {
                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Tutorial.getTutorial(Lunarbox_Capability_Resource_Tutorial.manageTutorialsHalogenM(dictManageTutorials))(id))(function (tutorial) {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v) {
                            var $57 = {};
                            for (var $58 in v) {
                                if ({}.hasOwnProperty.call(v, $58)) {
                                    $57[$58] = v[$58];
                                };
                            };
                            $57.tutorial = Network_RemoteData.fromEither(tutorial);
                            return $57;
                        });
                    });
                });
                var fetchProjects = Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Project.getProjects(Lunarbox_Capability_Resource_Project.manageUserHalogenM(dictManageProjects)))(function (result) {
                    var projects = (function () {
                        if (result instanceof Data_Either.Right) {
                            var mkProject = function (v) {
                                return Lunarbox_Data_Tutorial.UserProject(new Data_Tuple.Tuple(v.name, v.id));
                            };
                            return Network_RemoteData.Success.create(Data_Functor.map(Data_Functor.functorArray)(mkProject)(result.value0.userProjects));
                        };
                        if (result instanceof Data_Either.Left) {
                            return new Network_RemoteData.Failure(result.value0);
                        };
                        throw new Error("Failed pattern match at Lunarbox.Component.TutorialEditor (line 118, column 18 - line 122, column 32): " + [ result.constructor.name ]);
                    })();
                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v) {
                        var $67 = {};
                        for (var $68 in v) {
                            if ({}.hasOwnProperty.call(v, $68)) {
                                $67[$68] = v[$68];
                            };
                        };
                        $67.projects = projects;
                        return $67;
                    });
                });
                var handleAction = function (v) {
                    if (v instanceof HandleTutorial) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Tutorial.saveTutorial(Lunarbox_Capability_Resource_Tutorial.manageTutorialsHalogenM(dictManageTutorials))(v1.id)({
                                name: v.value0.name,
                                base: v.value0.base.value1,
                                solution: v.value0.solution.value1,
                                content: v.value0.content
                            }))(function (response) {
                                if (response instanceof Data_Either.Left) {
                                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                        var $73 = {};
                                        for (var $74 in v2) {
                                            if ({}.hasOwnProperty.call(v2, $74)) {
                                                $73[$74] = v2[$74];
                                            };
                                        };
                                        $73.projects = new Network_RemoteData.Failure(response.value0);
                                        return $73;
                                    });
                                };
                                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                            });
                        });
                    };
                    if (v instanceof Delete) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            return v1.id;
                        }))(function (id) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Tutorial.deleteTutorial(Lunarbox_Capability_Resource_Tutorial.manageTutorialsHalogenM(dictManageTutorials))(id))(function (v1) {
                                if (v1 instanceof Data_Either.Left) {
                                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                        var $88 = {};
                                        for (var $89 in v2) {
                                            if ({}.hasOwnProperty.call(v2, $89)) {
                                                $88[$89] = v2[$89];
                                            };
                                        };
                                        $88.projects = new Network_RemoteData.Failure(v1.value0);
                                        return $88;
                                    });
                                };
                                return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(Lunarbox_Data_Route.Projects.value);
                            });
                        });
                    };
                    if (v instanceof Play) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            return v1.id;
                        }))((function () {
                            var $96 = Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate));
                            return function ($97) {
                                return $96(Lunarbox_Data_Route.Tutorial.create($97));
                            };
                        })());
                    };
                    if (v instanceof Init) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.fork(fetchTutorial)))(function () {
                            return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.fork(fetchProjects));
                        });
                    };
                    throw new Error("Failed pattern match at Lunarbox.Component.TutorialEditor (line 81, column 18 - line 108, column 32): " + [ v.constructor.name ]);
                };
                return Halogen_Component.mkComponent({
                    initialState: Record.merge()()({
                        projects: Network_RemoteData.NotAsked.value,
                        tutorial: Network_RemoteData.NotAsked.value
                    }),
                    render: render,
                    "eval": Halogen_Component.mkEval({
                        handleAction: handleAction,
                        handleQuery: Halogen_Component.defaultEval.handleQuery,
                        receive: Halogen_Component.defaultEval.receive,
                        initialize: new Data_Maybe.Just(Init.value),
                        finalize: Halogen_Component.defaultEval.finalize
                    })
                });
            };
        };
    };
};
module.exports = {
    component: component
};
